import { Button, MarketingUpwardGraphIcon, Theme } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    border: `1px solid ${Theme.borderColor}`,
    borderRadius: '4px',
    justifyContent: 'space-between',
    padding: 16,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    marginBottom: 24,
  },
  block: {
    display: 'flex',
    alignItems: 'center',
  },
  linkText: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.43,
    letterSpacing: '-0.08px',
    '& a': {
      color: Theme.infoColor,
    },
  },
});

const SuggestionsBanner = ({ learnMoreLink, actionButton, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.block}>
        <MarketingUpwardGraphIcon style={{ marginRight: '24px', height: 'auto' }} />
        {children}
      </div>
      {actionButton && (
        <div className={classes.block}>
          <Button onClick={actionButton.onClick} variant="primary">
            {actionButton.text}
          </Button>
        </div>
      )}
      {learnMoreLink && (
        <div>
          <p className={classes.linkText}>
            <a href={learnMoreLink} target="_blank" rel="noreferrer">
              Learn more about how this works.
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

SuggestionsBanner.propTypes = {
  learnMoreLink: PropTypes.string,
  actionButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  children: PropTypes.node,
};

export default SuggestionsBanner;
